import dayjs from 'dayjs'
import React, { useState } from 'react'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../../api'
import Responsive from '../../assets/config/Responsive'
import CopyIcon from '../../assets/icons/JSX/CopyIcon'
import DownloadIcon from '../../assets/icons/JSX/DownloadIcon'
import LogoGe from '../../assets/icons/JSX/LogoGe'
import TravelServiceIcon from '../../assets/icons/JSX/TravelServiceIcon'
import WelcomerCategoryIcon from '../../assets/icons/JSX/WelcomerCategoryIcon'
import PetCategoryIcon from '../../assets/icons/JSX/PetCategoryIcon'
import TplCategoryIcon from '../../assets/icons/JSX/TplCategoryIcon'
import Colors from '../../assets/styles/Colors'
import { Container } from '../../assets/styles/GlobalStyle'
import Loader from '../../components/Loader'
import NotFound404 from '../../components/NotFound404'
import { useTranslation } from 'react-i18next'

const DownloadPolicies = () => {
  const urlEncode = window?.location?.pathname?.split('/')?.[2]
  const { t } = useTranslation()

  const { data: policies, isLoading: isPoliciesLoading } = api.useGetPublicPoliciesQuery(urlEncode, {
    skip: !urlEncode && true,
  })
  // for copy function
  const [copied, setCopied] = useState<boolean>(false)

  // copy policy numner
  const copyPolicyNumber = (e: any) => {
    e.stopPropagation()
    navigator.clipboard.writeText(e.currentTarget.innerText)
    setCopied(true)
    toast.success(`${t('copied')}`)
    // for change color in copied text
    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }

  return isPoliciesLoading ? (
    <Loader />
  ) : !policies ? (
    <NotFound404 />
  ) : (
    <Wrapper>
      <Head>
        <Container>
          <LogoGe />
        </Container>
      </Head>

      <Container>
        <TitleH2>{t('downloadPolicies')}</TitleH2>

        <ItemsBlock>
          {policies?.map((policy, index) => {
            return (
              <Card key={index}>
                <Item>
                  {policy.policyType?.toLowerCase() === 'travel' && <TravelServiceIcon className="product-icon" />}
                  {policy.policyType?.toLowerCase() === 'welcomer' && <WelcomerCategoryIcon className="product-icon" />}
                  {policy.policyType?.toLowerCase() === 'tpl' && <TplCategoryIcon className="product-icon" />}
                  {policy.policyType?.toLowerCase() === 'pet' && <PetCategoryIcon className="product-icon" />}
                </Item>

                <Item>
                  <div>{policy.policyType}</div>
                  <div>{policy.companyName}</div>
                </Item>

                <Item>
                  <VerticalLine />
                </Item>

                <Item>
                  <div
                    style={{
                      textTransform: 'capitalize',
                    }}
                  >
                    {policy.insurerFullName}
                  </div>
                  <div>
                    {t('policyNumber')}: {policy.policyNumber}
                  </div>
                </Item>

                <Item>
                  <VerticalLine />
                </Item>

                <Item>
                  <div>
                    {t('start')}: {dayjs(policy.policyStartDate).format('DD.MM.YYYY')}
                  </div>
                  <div>
                    {t('end')}: {dayjs(policy.policyEndDate).format('DD.MM.YYYY')}
                  </div>
                </Item>

                <Item>
                  <VerticalLine />
                </Item>

                <Item>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      textTransform: 'capitalize',
                    }}
                  >
                    {policy.policyStatus}
                    <StatusCircle
                      style={{
                        backgroundColor:
                          policy.policyStatus === 'active'
                            ? Colors.java
                            : policy.policyStatus === 'pending'
                            ? Colors.Primary
                            : Colors.primaryRed,
                      }}
                    />
                  </div>
                </Item>

                <Item>
                  <VerticalLine />
                </Item>

                <Item>
                  <DownloadBtn onClick={() => window.open(policy.policyUrl, '_blank', 'noreferrer')}>
                    <DownloadIconStyle />
                  </DownloadBtn>
                </Item>
              </Card>
            )
          })}
        </ItemsBlock>

        {/* mobile */}

        <MobileItemsBlock>
          {policies.map((policy, index) => {
            return (
              <Card key={index}>
                <Item>
                  <div>
                    <div
                      style={{
                        fontSize: '18px',
                        fontWeight: 500,
                      }}
                    >
                      {policy.policyType}
                    </div>
                    <div
                      style={{
                        color: Colors.nevadaGrey,
                      }}
                    >
                      {t('company')}: {policy.companyName}
                    </div>
                  </div>

                  <div>
                    <DownloadBtn onClick={() => window.open(policy.policyUrl, '_blank', 'noreferrer')}>
                      <DownloadIconStyle />
                    </DownloadBtn>
                  </div>
                </Item>

                <Item>
                  <div>
                    <div
                      style={{
                        textTransform: 'capitalize',
                        color: Colors.nevadaGrey,
                      }}
                    >
                      <span
                        style={{
                          color: Colors.primaryBlack,
                        }}
                      >
                        {policy.insurerFullName}
                      </span>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      onClick={(event) => copyPolicyNumber(event)}
                    >
                      {policy.policyNumber}
                      <CopyIcon
                        style={{
                          height: '11px',
                          width: '11px',
                          marginLeft: '6px',
                          marginTop: '2px',
                          color: copied ? Colors.primaryGreen : Colors.primaryGrey,
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    {policy.policyType?.toLowerCase() === 'travel' && <TravelServiceIcon className="product-icon" />}
                    {policy.policyType?.toLowerCase() === 'welcomer' && (
                      <WelcomerCategoryIcon className="product-icon" />
                    )}
                    {policy.policyType?.toLowerCase() === 'tpl' && <TplCategoryIcon className="product-icon" />}
                    {policy.policyType?.toLowerCase() === 'pet' && <PetCategoryIcon className="product-icon" />}
                  </div>
                </Item>

                <HL />

                <Item>
                  <div>
                    {t('start')}: {dayjs(policy.policyStartDate).format('DD.MM.YYYY')}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      textTransform: 'capitalize',
                      color: Colors.primaryBlack,
                    }}
                  >
                    {policy.policyStatus}
                    <StatusCircle
                      style={{
                        backgroundColor:
                          policy.policyStatus === 'active'
                            ? Colors.java
                            : policy.policyStatus === 'pending'
                            ? Colors.Primary
                            : Colors.primaryRed,
                      }}
                    />
                  </div>
                </Item>
              </Card>
            )
          })}
        </MobileItemsBlock>
      </Container>
    </Wrapper>
  )
}

const StatusCircle = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 3px;
  margin-left: 6px;
  margin-bottom: -2px;
`
const DownloadIconStyle = styled(DownloadIcon)`
  width: 24px;
  height: 24px;

  ${Responsive.tablet} {
    width: 20px;
    height: 20px;
  }
  ${Responsive.mobile} {
    width: 20px;
    height: 20px;
  }
`
const HL = styled.div`
  display: none;
  height: 1px;
  width: 100%;
  background-color: ${Colors.secondaryGrey};

  ${Responsive.tablet} {
    display: block;
  }
  ${Responsive.mobile} {
    display: block;
  }
`
const DownloadBtn = styled.button`
  width: 40px;
  height: 40px;
  margin: 0;
  padding: 0px;
  border-radius: 4px;
  background-color: ${Colors.grey};
  border: 0px;
  display: grid;
  place-items: center;
  outline: none;

  &:hover {
    opacity: 0.8;
  }

  ${Responsive.tablet} {
    width: 32px;
    height: 32px;
  }
  ${Responsive.mobile} {
    width: 32px;
    height: 32px;
  }
`
const VerticalLine = styled.div`
  width: 1px;
  height: 40px;
  background-color: ${Colors.secondaryGrey};
`
const Item = styled.div`
  background-color: ${Colors.white};
  /*  */
  div {
    font-size: 14px;
    &:first-child {
      color: ${Colors.primaryBlack};
    }
    &:last-child {
      color: ${Colors.nevadaGrey};
    }
  }

  .product-icon {
    width: 118.6px;
    height: 72px;
  }
`
const Card = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 48px 32px;
  border-radius: 8px;
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  background-color: ${Colors.white};
  margin-bottom: 24px;
`
const MobileItemsBlock = styled.div`
  display: none;
  ${Card} {
    flex-direction: column;
    padding: 20px;
    margin-bottom: 0px;
  }
  ${Item} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 18px;

    &:last-child {
      margin-top: 18px;
      margin-bottom: 5px;
    }

    .product-icon {
      width: 102.2px;
      height: 53.7px;
    }
  }
  /*  */
  ${Responsive.tablet} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr;
    gap: 20px;
  }
  ${Responsive.mobile} {
    display: block;
    ${Card} {
      margin-bottom: 20px;
    }
  }
`
const ItemsBlock = styled.div`
  ${Responsive.tablet} {
    display: none;
  }
  ${Responsive.mobile} {
    display: none;
  }
`
const TitleH2 = styled.h2`
  font-size: 36px;
  color: ${Colors.primaryBlack};
  margin-block: 56px;
  text-align: center;

  ${Responsive.tablet} {
    font-size: 18px;
    margin-block: 24px;
  }
  ${Responsive.mobile} {
    font-size: 18px;
    margin-block: 24px;
  }
`
const Head = styled.div`
  height: 88px;
  width: 100%;
  background-color: ${Colors.white};
  display: flex;
  align-items: center;

  svg {
    width: 90px;
    height: 38.8px;
  }

  ${Responsive.tablet} {
    height: 64px;

    svg {
      width: 64.9px;
      height: 28px;
    }
  }
  ${Responsive.mobile} {
    height: 64px;

    svg {
      width: 64.9px;
      height: 28px;
    }
  }
`
const Wrapper = styled.div`
  background-color: ${Colors.backgroundGrey};
  min-height: 100vh;
`
export default DownloadPolicies
